import 'antd/dist/antd.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import Home from 'pages/Home';
import TransactionsHistory from 'pages/TransactionsHistory';
import Setting from 'pages/Setting';
import GenerateQrCode from 'pages/GenerateQRCode';

import ChangePassword from 'pages/ChangePassword';
import Layout from 'components/Layout';
import {
  HomeOutlined,
  UnorderedListOutlined,
  SettingOutlined,
  QrcodeOutlined,
} from '@ant-design/icons';

const routes = [
  {
    path: '/',
    component: Home,
    name: 'routeName.home',
    icon: <HomeOutlined />,
    exact: true,
  },
  {
    path: '/generate-qr-code',
    component: GenerateQrCode,
    name: 'routeName.QR',
    icon: <QrcodeOutlined />,
  },
  {
    path: '/transaction-history',
    component: TransactionsHistory,
    name: 'routeName.transactionHistory',
    icon: <UnorderedListOutlined />,
  },
  {
    path: '/setting',
    component: Setting,
    name: 'routeName.setting',
    icon: <SettingOutlined />,
  },
  {
    path: '/account/change-password',
    component: ChangePassword,
    showOnSideBar: false,
    exact: true,
  },
];

const AuthorizedRoutes = (props) => {
  const defaultRoute = routes[0];
  return (
    <Layout routes={routes}>
      <Switch>
        {routes.map((routeItem, index) => (
          <Route
            key={index}
            path={routeItem.path}
            component={routeItem.component}
            exact={routeItem.exact}
          />
        ))}

        {defaultRoute && <Redirect to={defaultRoute.path} />}
      </Switch>
    </Layout>
  );
};
export default AuthorizedRoutes;
